import Avatar from "../assets/image/avatar.png";
import nv from "../assets/image/employee.png";
import service from "../assets/image/service.png";
import money from "../assets/image/money.png";
import cardAtm from "../assets/image/cardAtm.png";
import creditMachine from "../assets/image/creditMachine.png";
import payon from "../assets/image/payon.png";
import imagePay from "../assets/image/image_23.png";
import resultNull from "../assets/image/resultNull.png";
import imgDefault from "../assets/image/imgDefault.png";
import home_blog from "../assets/image/home-blog.png";
import home_partners from "../assets/image/home-partner.png";
import massage from "../assets/image/tags/message.svg";
import eyelash_extensions from "../assets/image/tags/eyelash_extensions.jpg";
import nails from "../assets/image/tags/nails.svg";
import nhaKhoa from "../assets/image/tags/nhaKhoa.svg";
import skinCare from "../assets/image/tags/skinCare.svg";
import spa from "../assets/image/tags/spa.svg";
import yoga from "../assets/image/tags/yoga.svg";
import clinic from "../assets/image/tags/clinic.jpg";
import sellerCenterImg from "../assets/image/sellerCenterImg.jpeg";
import beautyx from "../assets/image/beautyx_icon.png";
import Partner from "assets/image/partner.png";
import iconAppointment from "assets/image/iconAppointment.png";
import awsStartups from "assets/image/aws.png";

// social
import facebook from "../assets/image/social/facebook.png";
import tiktok from "../assets/image/social/tiktok.png";
import youtube from "../assets/image/social/youtube.png";
import instagram from "../assets/image/social/instagram.png";
import qrCode from "../assets/icon/qr-code.svg";
import appStore from "../assets/image/appstore.png";
import playStore from "../assets/image/playstore.png";
import zalo from 'assets/image/social/zalo.png'

// payment method
import atm from "../assets/image/paymentMethod/atm.svg";
import jcb from "../assets/image/paymentMethod/jcb.svg";
import masterCard from "../assets/image/paymentMethod/masterCard.svg";
import mocaGrap from "../assets/image/paymentMethod/mocaGrap.svg";
import momoPayment from "../assets/image/paymentMethod/momoPay.svg";
import handPay from "../assets/image/paymentMethod/payHand.svg";
import phonePay from "../assets/image/paymentMethod/phonePay.svg";
import tikiPay from "../assets/image/social/tiki.png";
import visa from "../assets/image/paymentMethod/visa.svg";
import vnPay from "../assets/image/paymentMethod/vnPay.svg";
import zaloPay from "../assets/image/paymentMethod/zaloPay.svg";
import bannerBlur from "../assets/image/bannerBlur.png";
import beautyxSlogan from "assets/image/beautyxSlogan.png";
import beautyX from "assets/image/beautyX.svg"
import plashScreenPc from 'assets/image/plashScreenPc.png';
import bgNotiBtxPoint from 'assets/image/bgNotiBtxPoint.jpg';
import qrCodeTiki from 'assets/image/qrCodeTiki.png';
import qrCodeMomo from 'assets/image/qrCodeMomo.png';
import iconShoppee from 'assets/image/icon-shopee.png';
import iconVinID from 'assets/image/icon-vinid.png'
import portalDeal from 'assets/image/portalDeal.png'
import flagUK from 'assets/image/uk.png'
import flagVN from 'assets/image/vn.png'
import qrCodeZalo from 'assets/image/qrCodeZalo.png'
import bgTip from 'assets/image/bg-tip.jpg'
import tip from 'assets/image/tips.png'
import logoMyspa from 'assets/image/logo-myspa.png'
import logoMyspaWhite from 'assets/image/logo-myspa-white.png'
import viettelMoney from 'assets/icon/viettelpay.png'
import viettel from 'assets/icon/viettel.png'

const img = {
    logoMyspaWhite,
    logoMyspa,
    tip,
    bgTip,
    flagUK,
    flagVN,
    awsStartups,
    portalDeal,
    iconShoppee,
    iconVinID,
    bgNotiBtxPoint,
    appStore,
    playStore,
    qrCode,
    Avatar,
    nv,
    service,
    money,
    creditMachine,
    cardAtm,
    payon,
    imagePay,
    resultNull,
    imgDefault,
    sellerCenterImg,
    beautyx,
    bannerBlur,
    beautyxSlogan,
    home_blog,
    home_partners,
    beautyX,
    Partner,
    iconAppointment,
    plashScreenPc,
    qrCodeTiki, qrCodeMomo, qrCodeZalo
};
export const social = {
    facebook,
    tiktok,
    instagram,
    youtube,
    zalo
};
export const paymentMethod = {
    vnPay,
    zaloPay,
    handPay,
    visa,
    tikiPay,
    atm,
    jcb,
    masterCard,
    mocaGrap,
    phonePay,
    momoPayment,
    viettelMoney,
    viettel
};

export const imgTag = {
    massage,
    eyelash_extensions,
    nails,
    nhaKhoa,
    skinCare,
    spa,
    yoga,
    clinic,
};

export default img;
